"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var FlashWrapper = /** @class */ (function (_super) {
    __extends(FlashWrapper, _super);
    function FlashWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the container element of the component.
     */
    FlashWrapper.prototype.findRootElement = function () {
        return this.find('.awsui-flash');
    };
    /**
     * Returns the dismiss button.
     *
     * The dismiss button is only rendered when the `dismissible` property is set to `true`.
     */
    FlashWrapper.prototype.findDismissButton = function () {
        return this.find('.awsui-flash-dismiss button');
    };
    /**
     * Returns the action button.
     *
     * The action button is only rendered when the `buttonText` property is set.
     */
    FlashWrapper.prototype.findActionButton = function () {
        return this.find('.awsui-flash-action-button button');
    };
    FlashWrapper.prototype.findHeader = function () {
        return this.find('.awsui-flash-header');
    };
    FlashWrapper.prototype.findContent = function () {
        return this.find('[awsui-flash-region="content"]');
    };
    return FlashWrapper;
}(dom_1.ComponentWrapper));
exports.default = FlashWrapper;
//# sourceMappingURL=awsui-flash.js.map